export const CREATE_INSURANCE = "CREATE_INSURANCE";
export const FETCH_INSURANCES = "FETCH_INSURANCES";
export const FETCH_INSURANCE = "FETCH_INSURANCE";
export const EDIT_INSURANCE = "EDIT_INSURANCE";
export const DELETE_INSURANCE = "DELETE_INSURANCE";
